import { Lookup } from '../lookup.interface';
export const StreamTypes: { [name: string]: Lookup } = {
  A1: { displayValue: 'Minimal risk of long-term unemployment' },
  A2: { displayValue: 'Minimal risk of long-term unemployment (Limited digital access / literacy)' },
  B: { displayValue: ' Moderate risk of long-term unemployment' },
  C: { displayValue: 'High risk of long-term unemployment' },
};
